// Vanilla JavaScript Scroll to Anchor
// @ https://perishablepress.com/vanilla-javascript-scroll-anchor/
(function() {
    scrollTo();
})();

function scrollTo() {
    const links = document.querySelectorAll('.anchor-list__item__link');
    links.forEach(each => (each.onclick = scrollAnchors));

    const triggers = document.querySelectorAll('.anchor-list__trigger__link');
    triggers.forEach(each => (each.onclick = anchorToggle));
}

function scrollAnchors(e, respond = null) {
    const distanceToTop = el => {
        const distance = Math.floor(el.getBoundingClientRect().top);
        const headerHeight = Math.floor(document.getElementById("masthead").getBoundingClientRect().height);
        const navbarHeight = Math.floor(document.querySelector('.anchor-list').getBoundingClientRect().height);

        el.focus();
        anchorClose();

        if(distance < 0)
            return (distance - headerHeight - navbarHeight);
        else if(distance > 0)
            if(distance == (headerHeight + navbarHeight))
                return 0;
            else
                return (distance - navbarHeight);
        else
            return distance;
    };
    e.preventDefault();
    var targetID = (respond) ? respond.getAttribute('href') : this.getAttribute('href');
    const targetAnchor = document.querySelector(targetID);
    if (!targetAnchor) return;
    const originalTop = distanceToTop(targetAnchor);

    let sUsrAg = navigator.userAgent;
    if(sUsrAg.indexOf("Trident") > -1 || sUsrAg.indexOf("Edge") > -1){
        window.scrollBy(0, originalTop);
    }else{
        window.scrollBy({ top: originalTop, left: 0, behavior: 'smooth' });
    }
}

function anchorToggle(e, respond = null){
    e.preventDefault();
    var target = (respond) ? respond : this;
    var toggle = target.getAttribute('aria-controls');

    document.querySelector(toggle).classList.toggle('--open');

    if(target.getAttribute('aria-expanded') === 'false')
        target.setAttribute('aria-expanded', 'true');
    else
        target.setAttribute('aria-expanded', 'false');
}

function anchorClose(){
    const elements = document.querySelectorAll('.anchor-list .--open, .anchor-list [aria-expanded="true"]');
    elements.forEach(function (el) {
        el.classList.remove('--open');

        if(el.getAttribute('aria-expanded'))
            el.setAttribute('aria-expanded', 'false');
    });
}

window.addEventListener('DOMContentLoaded', () => {

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const id = entry.target.getAttribute('id');
            let link = document.querySelector('.anchor-list__item__link[href="#'+id+'"]');
            if (entry.intersectionRatio > 0) {
                if(link)
                    link.classList.add('--active');
            } else {
                if(link)
                    link.classList.remove('--active');
            }
        });
    });

    // Track all sections that have an `id` applied
    document.querySelectorAll('section[id]').forEach((section) => {
        observer.observe(section);
    });

});
